'use strict';
/**
 *
 * This event handler, should be used when an MMC upload button triggers the signup modal if a user is not logged in.
 *
 * Usage:
 *    data-sw-mmc-upload-or-signup
 **/

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var signupDialog = require('js/lib/notifications/sw-signup-dialog');


function mmcRedirect(){
  window.location.href = '/model/material-configurator/upload';
}

$(function () {
  $('body').on('click', '[data-sw-mmc-upload-or-signup]', function (event) {
    event.preventDefault();
    var LOGIN_SUCCESS_EVENT = 'sw-login-complete.mmc';
    if(!sw.data.user.isLoggedIn){
      signupDialog.openLogInSignUpDialog('login', null, '', null, 'event:' + LOGIN_SUCCESS_EVENT);
      sw.on(LOGIN_SUCCESS_EVENT, function () {
        sw.off(LOGIN_SUCCESS_EVENT);
        mmcRedirect();
      });
    }
    else {
      mmcRedirect();
    }
  });
});
